webpackJsonp([182],{

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @file Core things to execute upon page load
 * This is usually code that must operate at a global scope
 * @author SASS-IT, University of Ottawa
 */


if (document.documentElement.lang === 'fr-CA') {
  __webpack_require__(728);
  __webpack_require__(84);
  __webpack_require__(731);
}

/***/ })

},[727]);


// WEBPACK FOOTER //
// global/assets/js/core.min.js